"use strict";
module.exports = {
  MODE_ENV: "development",
  // BASE_API: "https://pub.servicesplus.cn/api/web",
  // IMAGE_API: "https://pub.servicesplus.cn/api"
  BASE_API: "http://192.168.4.79:9528/api/web",
  IMAGE_API: "http://192.168.4.79:9528/api"
};
